import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { HeaderTabs } from 'Modules/UniversalRequest/HeaderTabs';
import { ChangeEvent } from 'react';

interface IParentCategoriesHeaderContent {
  handleTabChange: (event: ChangeEvent<{}>, newValue: number) => void;
  tabValue: number;
  selectedCategoryId: number | null;
}

export const ParentCategoriesHeaderContent = ({
  handleTabChange,
  tabValue,
  selectedCategoryId,
}: IParentCategoriesHeaderContent) => {
  const isDesktop = useIsDesktop();
  return (
    <Stack gap={isDesktop ? '32px' : '40px'}>
      <Typography component='h2' fontSize={'24px'} textAlign={'center'}>
        {Dictionary[DICTIONARY.UniversalRequest].subtitle}
      </Typography>
      {!selectedCategoryId && (
        <HeaderTabs handleTabChange={handleTabChange} tabValue={tabValue} />
      )}
    </Stack>
  );
};
